import React from 'react';
import {type AIEvent, type AIResponse, type Citation, type SearchDocument} from "@/types";
import TypewriterMarkdown from "@/components/TypewriterMarkdown";

interface AnswerEventProps {
    event: AIEvent;
    citations?: Citation[];
    doc?: SearchDocument[];
    isLatestMessage: boolean;
    messageGroup?: AIResponse;
    groupIndex?: number;
    setMessages: React.Dispatch<React.SetStateAction<AIResponse[]>>;
    onUnderAnswer?: (num?: number) => void;
    conversationNo?: string;
    isEnd?: boolean

}

export const AnswerEvent = React.memo(({
                                           event,
                                           citations,
                                           doc,
                                           isLatestMessage,
                                           onUnderAnswer,
                                           conversationNo,
                                           isEnd
                                       }: AnswerEventProps) => {
    return (
        <div className="message answer">
            <div className="content answer-content">
                <TypewriterMarkdown
                    content={"answer" in event.data ? event.data.answer : ''}
                    speed={5}
                    citations={citations}
                    docs={doc}
                    onPDFClick={(pdf)=>{
                    }}
                    isLatestMessage={isLatestMessage}
                    onUnderAnswer={onUnderAnswer}
                    conversationNo={conversationNo}
                    isEnd={isEnd}
                />
            </div>
        </div>
    );
});
